import React from "react";
import { colors2 } from "oolib";
import { CardAnnoExplorer } from "@/components/analysisModules/AnnotationExplorer/comps/CardAnnoExplorer";
import { MIXPANEL_EVENTS_NAMING } from "@/mixpanel/MIXPANEL_EVENTS_NAMING";

const P = MIXPANEL_EVENTS_NAMING.CARD_CLICKED.properties;

// The report widgets' shell: bordered, rounder and shadowed, where the
// explorer page's card is flat and only lifts on hover.
const REPORT_CARD_SHELL_STYLE = {
  border: `1px solid ${colors2.grey10}`,
  borderRadius: "0.8rem",
  boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.06)",
};

const DEFAULT_META_BLOCK = [
  { key: "date", valuePath: "kp_date_published" },
  { key: "name", valuePath: "annotations.author.name" },
];

/**
 * The annotation card as the report widgets show it: the Annotation Explorer's
 * own card — so a click opens the source document scrolled to this annotation —
 * in compact form: no tag section, no document title, the widget's meta block,
 * inside the report's bordered shell. The card-click event names the report
 * and the widget it came from.
 */
export const AnnoCard = ({ singleAnno, lastCardObserverRef, cardConfigs, widgetName, reportId, widgetId, widgetIdx }) => (
  <CardAnnoExplorer
    singleAnno={singleAnno}
    lastCardObserverRef={lastCardObserverRef}
    cardShellStyle={REPORT_CARD_SHELL_STYLE}
    cardConfigs={{
      ...cardConfigs,
      disableTagsSection: true,
      disableTitleSection: true,
      metaBlock: cardConfigs?.metaBlock || DEFAULT_META_BLOCK,
    }}
    mixpanelContext={{
      [P.SURFACE]: "Report",
      [P.WIDGET]: widgetName,
      [P.REPORT_ID]: reportId,
      [P.WIDGET_ID]: widgetId,
      [P.WIDGET_INDEX]: widgetIdx,
    }}
  />
);
